module.exports = __webpack_public_path__ + "img/金课评审.6ebea8b5.png";